module.exports = "/_next/static/sounds/_/_/libs/ga-features/src/lib/digital-practice/assets/sounds/fx_feedback_starReward03.mp3";